import { render, staticRenderFns } from "./DonutChart21.vue?vue&type=template&id=b6fc1b9e&scoped=true"
import script from "./DonutChart21.vue?vue&type=script&lang=js"
export * from "./DonutChart21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fc1b9e",
  null
  
)

export default component.exports